
import { canonical } from "@utils";
import { getCMSCopy } from "@/common/services/cmsCopyService";

export default {
	name: "About",
	async asyncData({ $axios, $config }) {
		const cmsCopyKey = ".seo.landing.about-us";
		const cmsCopy = await getCMSCopy(
			$axios,
			$config,
			cmsCopyKey,
			process.env.version
		);

		return {
			pageTitle: cmsCopy?.data?.title || "",
			pageContent: cmsCopy?.data?.body || "",
			pageMetaTitle: cmsCopy?.data?.metaTitle || "",
			pageMetaDescription: cmsCopy?.data?.metaDescription || "",
		};
	},
	head() {
		return {
			title:
				this.pageMetaTitle ||
				"About WordFinder by YourDictionary: Who We Are and What We Do",
			meta: [
				{
					name: "description",
					content:
						this.pageMetaDescription ||
						"WordFinder by YourDictionary is the resource word game fans trust to help them win. Learn all about how we got started, our mission and our team in this overview.",
				},
			],
			link: [canonical(this.$route)],
		};
	},
};
